<template lang="pug">
  #app
    .big-red-line
    c-header(:lang="lang" @langChanged="langChanged")
    section-1(:lang="lang")
    section-2(:lang="lang")
    geography(:lang="lang")
    about(:lang="lang")
    contact(:lang="lang")
    c-footer(:lang="lang")
</template>

<script>
  import CHeader from './components/Header'
  import CFooter from './components/Footer'
  import Section1 from './views/sections/section1'
  import Section2 from './views/sections/section2'
  import About from './views/sections/about'
  import Geography from './views/sections/geography'
  import Contact from './views/sections/contact'

  export default {
    name: 'app',
    components: {
      CHeader,
      CFooter,
      Section1,
      Section2,
      About,
      Geography,
      Contact
    },
	data() {
	  return {
	    lang: 'ru'
	  }
	},
	methods: {
	  langChanged: function(data) {
	  console.log(data)
	    this.lang = data
	  }
	}
  }
</script>

<style lang="scss">
  #app {
    position: relative;
    &::before {
      content: '';
      display: flex;
      position: absolute;
      top: 0;
      height: 100%;
      width: 100%;
      background-image: url('~@/assets/svg/big-red-line.svg');
      background-size: 102vw;
      background-repeat: no-repeat;
      background-position: -7.5vw -55.5vw;
      z-index: 1;
    }
  }
</style>
